import { render, staticRenderFns } from "./base-info.vue?vue&type=template&id=6b7a1821&scoped=true"
import script from "./base-info.vue?vue&type=script&lang=js"
export * from "./base-info.vue?vue&type=script&lang=js"
import style0 from "./base-info.vue?vue&type=style&index=0&id=6b7a1821&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7a1821",
  null
  
)

export default component.exports